import { render, staticRenderFns } from "./peripheryEvaluate.vue?vue&type=template&id=385c1b32&"
import script from "./peripheryEvaluate.vue?vue&type=script&lang=js&"
export * from "./peripheryEvaluate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports